import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';
import { Button } from "react-bootstrap";
import SiteInvoiceFilterForm from "../../../components/installation/siteFilterForm/siteInvoiceFilterForm";
import SiteFilterForm from "../../../components/installation/siteFilterForm/siteFilterForm";

const UnclaimedFilter = ({
  applyFilter,
  showFilter = false,
  filterToggle,

}) => {
  const filterInputs = {
    transaction_id: '',
    payment_ref: '',
    transaction_amt: '',
    mode_collection: '',
    status: '',
    eligible_for_modification:'',
    trans_date: '',
    description: ''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
            <Button onClick={filterToggle} className="close"><i className="close"></i></Button>
          </div>
          <div className="filter-body scrollbar-styling">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
              }}
            >
              <ConstantInput
                label={localization.transactionId}
                value={filterFieldsData.transaction_id}
                regex={Regex.number.test(filterFieldsData.transaction_id)}
                type="text"
                handleChange={(val) =>
                  setFilterFieldsData({ ...filterFieldsData, transaction_id: val })
                }
              />
              <ConstantInput
                label={localization.paymentReference}
                value={filterFieldsData.payment_ref}
                regex={Regex.text.test(filterFieldsData.payment_ref)}
                type="text"
                handleChange={(val) =>
                  setFilterFieldsData({ ...filterFieldsData, payment_ref: val })
                }
              />
              <ConstantInput
                label={localization.transAmount}
                value={filterFieldsData.transaction_amt}
                type="number"
                handleChange={(val) =>
                  setFilterFieldsData({ ...filterFieldsData, transaction_amt: val })
                }
              />

              <ConstantInput
                label={localization.description}
                value={filterFieldsData.description}
                regex={Regex.number.test(filterFieldsData.description)}
                type="text"
                handleChange={(val) =>
                  setFilterFieldsData({ ...filterFieldsData, description: val })
                }
              />
              <DropDownInput
                label={localization.modeOfCollection}
                data={[
                  { id: 'CASH', name: "CASH", },
                  { id: 'CHEQUE', name: "CHEQUE", },
                  { id: 'NEFT', name: "NEFT", },
                  { id: 'IMPS', name: "IMPS", },
                  { id: 'RTGS', name: "RTGS", },
                  { id: 'UPI', name: "UPI", },
                ]}
                getIdValue={(val) => {
                  setFilterFieldsData({
                    ...filterFieldsData,
                    mode_collection: val.id,
                  })
                }
                }
              />

              <DropDownInput
                label={localization.status}
                data={[
                  { id: 'UNCLAIMED', name: "UNCLAIMED", },
                  { id: 'RAISED', name: "RAISED", }
                ]}
                getIdValue={(val) => {
                  setFilterFieldsData({
                    ...filterFieldsData,
                    status: val.id,
                  })
                }
                }
              />

              <DropDownInput
                label='Eligible for Modification'
                data={[
                  { id: true, name: "YES", },
                  { id: false, name: "NO", }
                ]}
                getIdValue={(val) => {
                  setFilterFieldsData({
                    ...filterFieldsData,
                    eligible_for_modification: val.id,
                  })
                }
                }
              />

              <DatePicker
                handleChange={(val) =>
                  setFilterFieldsData({ ...filterFieldsData, trans_date: val })
                }
                label={`Transaction Date`}
                required={false}
              />


              <br />
              <br />
              <br />
              <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                  {localization.applyFilter}
                  <img src="../images/arrow-right.png" alt="" />
                </button>
                <br />
                <br />
                <button
                  onClick={() => {
                    setFilterFieldsData(filterInputs);
                    applyFilter({});
                  }}
                  type="button"
                  className="btn btn-primary"
                >
                  {localization.removeFilter}
                </button>
              </div>
            </form>
          </div>
          )}

        </div>
      )}
    </div>
  );
};
export default UnclaimedFilter;
